import { useSearchParams } from '../useSearchParams';
import { siteIdParam } from '../../config/queryParams';
export function useSiteIdParam() {
    var searchParams = useSearchParams()[0];
    var siteIdString = searchParams.get(siteIdParam);
    return { siteId: siteIdString !== null && siteIdString !== void 0 ? siteIdString : undefined };
}
